import * as React from 'react';
import { connect } from 'react-redux';
import { Form, InputGroup } from 'react-bootstrap';
import '../ClaimsHistory/ClaimsHistory.css';
import ClaimInfo from '../ClaimsHistoryV2/ClaimInfo'
import ClaimInfoOld from '../ClaimsHistory/ClaimInfo'
import { DASHBOARD, FNOL } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import ClaimsCard from './ClaimsCard';
import { showCallMeModal } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import { getClaimProgress, getNextProgressStepName, setIsMobileInfo, setLoadingAndEmpty } from '../../../actions/claimHistoryActionsV2';
import { isMobile } from "react-device-detect";
import LoadingOrEmpty from './ClaimHistorySteps/LoadingOrEmpty';
import { setSelectedClaim } from '../../../actions/profileActions';

class ClaimsHistory extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentNav: "Claims History",
            searchText: ""
        };
        this.handleNav = this.handleNav.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleIsMobileInfo = this.handleIsMobileInfo.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    async handleNav(e: any) {
        let name = e.target.name;
        let value = e.target.id;
        await this.setState({ [name]: value });
    }

    handleClick(id) {
        this.setState({ currentNav: id });
    }

    handleIsMobileInfo() {
        if (isMobile) this.props.handleSetIsMobileInfo(true);
    }

    async componentDidMount() {
        if (this.props.profile.selectedPersonalClaim.claimID !== this.props.claimSubmit.selectedClaim.claimID) {
            await this.props.dispatchHandleSetLoadingAndEmpty(true, false);
            await this.props.dispatchSetSelectedClaim(this.props.profile.selectedPersonalClaim.claimNumber);
            await this.props.dispatchSetClaimProgress(this.props.profile.selectedPersonalClaim.claimID);
            await this.props.dispatchGetNextClaimV2Step();
            await this.props.dispatchHandleSetLoadingAndEmpty(false, false);
        }
    }

    public render() {
        const { profile } = this.props;
        
        let hasSteps = false
        if (this.props.claimSubmit.claimProgress) {
            if (this.props.claimSubmit.claimProgress.claimSteps) {
                if (this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() !== "overview").length > 0) {
                    hasSteps = true
                }
            }
        }
        let covers = <div></div>;
        if (profile.personalClaims !== undefined && profile.personalClaims !== "" && profile.personalClaims.length > 0 ) {
            covers = this.props.profile.personalClaims
                .filter((cover) => cover.claimTitle.toUpperCase().includes(this.state.searchText.toUpperCase()) || cover.riskItem.toUpperCase().includes(this.state.searchText.toUpperCase() || cover.claimNumber.toUpperCase().includes(this.state.searchText.toUpperCase())))
                .sort((a, b) => b.reportedDate.localeCompare(a.reportedDate))
                .map((cover) => {
                    return <div key={cover.claimNumber} >
                        <ClaimsCard id={cover.claimNumber} alertCount="0"
                            headerText={cover.claimTitle}
                            claimNr={cover.claimNumber}
                            bodyText={cover.riskItem}
                            claimStatus={cover.claimStatus}
                            claimStatusCategory={cover.claimStatusCategory}
                        />
                    </div>
                });
        }

        let nav = () =>
            <div id="ClaimsHistory-progress-block">
                <div className="row noma">
                    <div className="col-12 nopa">
                        <div className="claim-history-progress-block">
                            <div className="">
                                <p className="mb-0px font-size-25px font-weight-800 line-height-1 text-white">Your claims progress</p>
                            </div>
                            <div className="mt-10px">
                                <p className="font-weight-500 line-height-normal text-white">Check out all the claims you've submitted</p>
                            </div>
                        </div>
                        <div className="mb-3 center-text">
                            <InputGroup>
                                <Form.Control type="text" className="search" placeholder="Search" id="searchClaims" name="searchText" value={this.state.searchText} onChange={this.handleChange} />
                            </InputGroup>
                        </div>
                    </div>
                    <div className="col-12 nopa" onClick={this.handleIsMobileInfo}>{covers}</div>
                </div>
            </div >
        let isCorrectRiskItem = false;
        let isCorrectIncidentType = false;
        
        let info = () =><div></div>
        if ((this.props.claimsHistory.isLoading || this.props.claimsHistory.isEmpty)) {
            info = () => <LoadingOrEmpty />
        }
        else if (this.props.claimSubmit.selectedClaim.riskItemType && this.props.claimSubmit.selectedClaim.incidentType) {
            if (hasSteps) {
                info = () => <ClaimInfo />
            } else {
                info = () => <ClaimInfoOld />
            }
        }
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]

        return (
            <div id="ClaimHistory" className="container-fluid new-page-margins">
                <div className="new-breadcrumbwrapper breadcrumb-wrapper-claims-history-main-actual">
                    <KPBreadCrumb navList={BreadcrumbDetails} activePage="Claims progress" />
                </div>
                <div className="row new-page-main-row">
                    {/*/// DESKTOP VIEW ///*/}
                    <div className="col-12 nopa d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        <div className="row noma">
                            <div className="col col-notify-claim">
                                {nav()}
                            </div>
                            <div className="col col-fnol-right">
                                {info()}
                            </div>
                        </div>
                    </div>
                    {/*/// MOBILE VIEW ///*/}
                    <div className="col-12 d-block d-sm-block d-md-block d-lg-none d-xl-none nopa">
                        {!this.props.claimSubmit.isMobileInfo &&
                            <>
                                <div className="row noma">
                                    <div className="col-12 col-notify-claim-nomaxwidth">
                                        {nav()}
                                    </div>

                                </div>
                                {(this.props.claimsHistory.isLoading || this.props.claimsHistory.isEmpty) &&
                                    <LoadingOrEmpty />
                                }
                            </>
                        }
                        {this.props.claimSubmit.isMobileInfo &&
                            <div className="row">
                                <div className="col-12">
                                    {info()}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        claimSubmit: state.claimSubmit,
        claimsHistory: state.claimsHistory,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchHandleSetLoadingAndEmpty: (loading, empty) => dispatch(setLoadingAndEmpty(loading, empty)),
        dispatchSetSelectedClaim: (id) => dispatch(setSelectedClaim(id)),
        dispatchSetClaimProgress: (id) => dispatch(getClaimProgress(id)),
        dispatchGetNextClaimV2Step: () => dispatch(getNextProgressStepName()),
        handleSetIsMobileInfo: (flag) => dispatch(setIsMobileInfo(flag))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsHistory);